import styled from 'styled-components';

import {mq} from 'utils/responsive';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 40px 0;

  ${mq.ltsm`
    padding: 20px 20px 0;
  `}
`;

const Title = styled.div`
  font-family: Tiempos Headline;
  font-style: normal;
  font-weight: 600;
  font-size: 44px;
  line-height: 64px;
  letter-spacing: -0.01em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: ${({theme}) => theme.fieldset.title};

  ${mq.ltsm`
    font-size: 32px;
    line-height: 38px;
  `}
`;

const Subtitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: ${({theme}) => theme.fieldset.subtitle};
`;

const Description = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 32px;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: ${({theme}) => theme.fieldset.description};

  ${mq.ltsm`
    font-size: 16px;
    line-height: 28px;
  `}
`;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;
  margin: 32px 0 0;

  ${mq.ltsm`
    margin: 18px 0 0;
  `}
`;

const Fieldset = ({
  title, subtitle, description, children, ...props
}) => (
  <Wrapper>
    {subtitle && (<Subtitle>{subtitle}</Subtitle>)}
    {title && (<Title>{title}</Title>)}
    {description && (<Description>{description}</Description>)}
    <Fields {...props}>
      {children}
    </Fields>
  </Wrapper>
);

export default Fieldset;

export const GridFieldset = styled(Fieldset)`
  display: grid;
  grid-template-areas: '${({layout}) => layout.join("'\n'")}';
  grid-template-columns: ${({columns}) => columns};
  gap: 28px 20px;

  ${mq.ltsm`
    grid-template-areas: '${({mobileLayout, layout}) => (mobileLayout || layout).filter((area) => area).join("'\n'")}';
    grid-template-columns: ${({mobileColumns, columns}) => mobileColumns || columns};
    gap: 20px;
  `}
`;
